import React from 'react';
import { useNavigate } from 'react-router-dom';

import Settings from '../../components/screens/settings/Settings';

const SettingsContainer = () => {
  const navigate = useNavigate();

  return <Settings navigateBack={() => navigate(-1)} />;
};

export default SettingsContainer;
